import './MapBtns.css';

import React, {Component, Fragment} from 'react';
import { Redirect} from 'react-router-dom';
import { Responsive } from "../tools/Responsive";
import Services from '../tools/Services';


import Fab  from '@material-ui/core/Fab';
import Grid from '@material-ui/core/Grid';

import Power        from '@material-ui/icons/PowerSettingsNew';
import AddIcon      from '@material-ui/icons/Add';
import MenuIcon     from '@material-ui/icons/Menu';
import RemoveIcon   from '@material-ui/icons/Remove';
import SettingsIcon from '@material-ui/icons/Settings';


export default class MapBtns extends Component {
    constructor(props) {
        super(props);
        this.state = {
            redirect: false,
        }
    }

    // Handles
    handleLogOut = (e) => {
        
        // Remove every token that could be there
        Services.clearLocalStorage();
        
        // Redirect to Login
        this.setState({
            redirect: true
        });
    }
    
    handleSettingsClick = (e) => {
        let ev = new CustomEvent('settings');
        window.dispatchEvent(ev);
    }
    
    // Zoom
    handleZoomIn = (e) => {
        let zoom = this.props.map.getZoom();
        this.props.map.setZoom(zoom + 1);
    }
    
    handleZoomOut = (e) => {
        let zoom = this.props.map.getZoom();
        this.props.map.setZoom(zoom - 1);
    }

    render() {
            let { redirect } = this.state;
            return (
                <Fragment>
                    <div id='MapBtns'>
                        {redirect && <Redirect to='/' />}
                        <div>
                            <Fab hover className='mapBtn marginBot' onClick={this.handleLogOut} variant="round" >
                                <Power hover ></Power>
                            </Fab>
                            <Fab className='mapBtn settings' onClick={this.handleSettingsClick} variant="round" >
                                <SettingsIcon></SettingsIcon>
                            </Fab>
                        </div>
                        
                        <div className="directionsDiv">
                            <div className="upIcon">
                                <Fab className='mapBtn directions'  onClick={this.handleZoomIn}>
                                    <AddIcon></AddIcon>
                                </Fab>
                            </div>
                            <div>
                                <Fab className='mapBtn directions'  variant="round" onClick={this.handleZoomOut} >
                                    <RemoveIcon></RemoveIcon>
                                </Fab>
                            </div>
                        </div>
                        { 
                    // hide menu icon if sidebar is open
                    (!this.props.scheduleOpen && !this.props.aircraftOpen && !this.props.airportOpen) && <Fab variant="round" className='mapBtn menuBtn' onClick={this.props.handleSchedule}>
                            <MenuIcon></MenuIcon>
                        </Fab>}
                    </div>
                    <Responsive  displayIn={["Mobile"]}>
                        <Grid className="MobileButtons" >
                        
                            <Fab id="menuBtnMobile" className="MobileFab">
                                <MenuIcon onClick={this.props.menuMobileToggle}></MenuIcon>
                            </Fab>
                            
                            <Fab className="MobileFab">
                                <SettingsIcon onClick={this.handleSettingsClick}></SettingsIcon>
                            </Fab>
                            
                            <Fab className="MobileFab">
                                <Power onClick={this.handleLogOut}></Power>
                            </Fab>
                            
                        </Grid>
                    </Responsive>
                </Fragment>
            )
    }
}
                    

                       
                     
                     
                       
                      